var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    {
      class: [_vm.$style["mds-field-error"], _vm.classObject, _vm.sizeClass],
      attrs: { "data-mds-version": _vm.version },
    },
    [
      _vm._t("default", function () {
        return [_vm._v(_vm._s(_vm.text))]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }